import { render, staticRenderFns } from "./KCColorPicker.vue?vue&type=template&id=27348bfe&"
import script from "./KCColorPicker.vue?vue&type=script&lang=js&"
export * from "./KCColorPicker.vue?vue&type=script&lang=js&"
import style0 from "./KCColorPicker.vue?vue&type=style&index=0&id=27348bfe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports